// extracted by mini-css-extract-plugin
export default {"wrapper":"MainScreen_wrapper__c4KRm","content":"MainScreen_content__vm8tE","documents_list":"MainScreen_documents_list__tga24"};